import { z } from 'zod';
import { InputRegexMap, OnboardingFormFields } from '@Types/index.ts';
import { t } from 'i18next';

export const zipSchema = z.object({
  [OnboardingFormFields.ZIP]: z
    .string()
    .trim()
    .describe('zip')
    .min(1, { message: t('enErrors:address.zipRequired') })
    .regex(InputRegexMap.zipCode, t('enErrors:address.zipInvalid'))
    .min(5, { message: t('enErrors:address.zip') })
    .max(5, { message: t('enErrors:address.zip') }),
});
